export const applyIoTLiveUpdate = (prevDevices, msg) => {
    if (!msg || msg.type !== "iot_update" || !msg.trackingNumber) {
        return prevDevices;
    }

    const updatedDevice = {
        id: msg.deviceId,
        trackingNumber: msg.trackingNumber,
        latitude: msg.latitude,
        longitude: msg.longitude,
        lastUpdated: msg.updatedAt || new Date().toISOString(),
        isOnline: true,
        predicted: msg.predicted ?? null,
        stats: msg.stats ?? null,
        eta: msg.eta ?? null,
        arrived: msg.arrived ?? false,
        autoStatus: msg.autoStatus ?? null,
    };

    const exists = prevDevices.some(
        (d) => d.trackingNumber === msg.trackingNumber
    );

    if (!exists) {
        return [...prevDevices, updatedDevice];
    }

    return prevDevices.map((d) =>
        d.trackingNumber === msg.trackingNumber
            ? { ...d, ...updatedDevice }
            : d
    );
};